/**
 * formatPhone — pretty-print a phone number as (614) 689-6706 for display
 * + as the user types. Strips every non-digit; returns "" for empty/falsy
 * input. iter-45 — director asked to make raw 10-digit numbers readable.
 */
export function formatPhone(raw) {
  if (raw == null) return "";
  const digits = String(raw).replace(/\D+/g, "");
  if (!digits) return "";
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  // 11+ digits — keep only first 10 (most US numbers prefixed with 1)
  const ten = digits.slice(-10);
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}

/** Strip formatting and return the bare 10-digit number (or whatever the
 * user actually typed for non-US numbers). */
export function unformatPhone(formatted) {
  if (!formatted) return "";
  return String(formatted).replace(/\D+/g, "");
}
